import { history } from '~spa/Router/memoryHistory';
import {
    BREADCRUMBS_URL_SPECTATE_PRODUCT_MAPPING,
} from './constants';

const getBreadcrumbSpectateProduct = key => BREADCRUMBS_URL_SPECTATE_PRODUCT_MAPPING[key] ?? key;

export const generateBackButtonSpectateProduct = (breadcrumbData) => {
    const breadcrumbLength = breadcrumbData.length;
    const { context, systemUrlPath = '' } = history?.location?.state?.context ?? {};
    const currentUrlSegments = systemUrlPath.split('/').filter(Boolean);
    const [firstUrlSegment, secondUrlSegment] = currentUrlSegments;
    const levelOneAttribute = getBreadcrumbSpectateProduct(firstUrlSegment);

    if (breadcrumbLength <= 2 ) {
        const mappedData = secondUrlSegment && getBreadcrumbSpectateProduct(secondUrlSegment);
        const levelTwoAttribute = mappedData || 'main';

        return `${levelOneAttribute};${levelTwoAttribute};back-button`;
    }

    const pageContextAttribute = getBreadcrumbSpectateProduct(context) || secondUrlSegment;

    return `${levelOneAttribute};${pageContextAttribute};back-button`;
};
